module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-back001.71617b56.jpg";